// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Quote editor & summary ── */
.q-toolbar { flex-wrap: wrap; }
.q-body { padding: 12px 16px 32px; }
.q-muted { color: var(--text-muted); font-size: 12px; }
.q-warn { color: #dcaa00; font-size: 12px; }
.q-error { color: var(--red); font-size: 12px; }
.q-unsaved { color: #dcaa00; font-size: 12px; font-style: italic; }
.q-spacer { flex: 1; }
.q-pad { padding: 8px 0; }
.q-r,
.q-table th.q-r { text-align: right; font-variant-numeric: tabular-nums; }
.q-tag { font-weight: 600; white-space: nowrap; }
.q-ellipsis { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 280px; }
.q-banner {
  background: var(--red-dim);
  color: var(--text-primary);
  padding: 8px 12px;
  border-radius: 4px;
  margin-bottom: 12px;
}

/* Scoped under .q-body so they beat the global input:not([type=checkbox]) rule */
.q-body .q-input {
  background: var(--bg-input);
  border: 1px solid var(--border);
  border-radius: 2px;
  color: var(--text-primary);
  font-size: 12px;
  padding: 3px 6px;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
}
.q-body .q-input:focus { outline: none; border-color: var(--accent-light); }
.q-body .q-input:disabled { color: var(--text-muted); }
.q-body .q-num { text-align: right; width: 100px; }
.q-body .q-qty { width: 64px; }
.q-body .q-pct { width: 64px; }
.q-body .q-ean { min-width: 120px; }
.q-body .q-wide { min-width: 220px; }
.q-body select.q-input { min-width: 120px; }
.q-body .q-input.q-missing { border-color: #dcaa00; }

.q-header {
  display: grid;
  grid-template-columns: minmax(200px, 360px) 140px 150px;
  gap: 10px 14px;
  margin-bottom: 16px;
}
.q-header label,
.q-inline {
  display: flex;
  flex-direction: column;
  gap: 3px;
  font-size: 11px;
  color: var(--text-secondary);
}
.q-inline { flex-direction: row; align-items: center; gap: 6px; }

.q-section {
  border-top: 1px solid var(--border);
  padding: 12px 0 8px;
}
.q-section-head {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 8px;
}
.q-section-head h3 { margin: 0; font-size: 14px; font-weight: 600; color: var(--text-primary); }

.q-table-wrap { overflow-x: auto; margin-bottom: 8px; }
.q-table td { vertical-align: middle; }
.q-table tfoot td { font-weight: 600; border-bottom: none; padding-top: 6px; }
.q-table .q-actions { width: 28px; padding: 0 4px; }
.q-table tr:hover td { background: transparent; }
.q-summary tr.q-clickable { cursor: pointer; }
.q-summary tr.q-clickable:hover td { background: var(--bg-hover); }

.q-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  color: var(--text-muted);
  font-size: 12px;
  cursor: pointer;
  padding: 2px 0;
}
.q-link:hover:not(:disabled) { color: var(--text-primary); }
.q-link:disabled { opacity: 0.5; cursor: default; }

.q-toggle {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  color: var(--text-secondary);
  font-size: 12px;
  cursor: pointer;
  padding: 4px 0;
}
.q-toggle svg { transition: transform 0.15s; }
.q-toggle .q-open { transform: rotate(90deg); }

/* Cable picker */
.q-picker {
  border: 1px solid var(--border);
  border-radius: 4px;
  background: var(--bg-secondary);
  margin-bottom: 10px;
}
.q-picker-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  padding: 8px;
  border-bottom: 1px solid var(--border);
  color: var(--text-muted);
}
.q-body .q-picker-search { flex: 1 1 160px; width: auto; }
.q-body .q-picker-bar .group-filter { width: auto; flex: 0 1 170px; }
.q-picker-list { max-height: 320px; overflow-y: auto; padding: 4px 0; }
.q-picker-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 3px 10px;
  font-size: 12px;
  cursor: pointer;
}
.q-picker-row:hover { background: var(--bg-hover); }
.q-picker-row .q-ellipsis { flex: 1; max-width: none; }

/* Item groups (one per .sep file) */
.q-group { margin-bottom: 14px; }
.q-group-head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 4px;
}
.q-group-name { font-weight: 600; font-size: 13px; max-width: 320px; }

/* Hours: rates next to the hour lines */
.q-hours { display: flex; gap: 16px; align-items: flex-start; flex-wrap: wrap; }
.q-rates { flex: 0 1 320px; }
.q-hour-lines { flex: 1 1 480px; }

/* Totals */
.q-total-table { border-collapse: collapse; min-width: 420px; font-size: 13px; }
.q-total-table td { padding: 4px 10px; color: var(--text-primary); }
.q-total-table td:first-child { padding-left: 0; }
.q-total-sub td { border-top: 1px solid var(--border); font-weight: 600; }
.q-total-grand td { border-top: 2px solid var(--text-muted); font-weight: 700; font-size: 15px; }

@media (max-width: 768px), (hover: none) and (max-width: 1024px) {
  .q-body { padding: 10px 12px 32px; }
  .q-header { grid-template-columns: minmax(0, 1fr); }
  .q-body .q-input { font-size: 16px; } /* no zoom on focus in iOS */
  .q-total-table { min-width: 0; width: 100%; }
  .q-hours { flex-direction: column; }
  .q-rates, .q-hour-lines { flex: 1 1 auto; width: 100%; }
}
`, "",{"version":3,"sources":["webpack://./src/components/quotes/Quotes.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC,aAAa,eAAe,EAAE;AAC9B,UAAU,uBAAuB,EAAE;AACnC,WAAW,wBAAwB,EAAE,eAAe,EAAE;AACtD,UAAU,cAAc,EAAE,eAAe,EAAE;AAC3C,WAAW,iBAAiB,EAAE,eAAe,EAAE;AAC/C,aAAa,cAAc,EAAE,eAAe,EAAE,kBAAkB,EAAE;AAClE,YAAY,OAAO,EAAE;AACrB,SAAS,cAAc,EAAE;AACzB;kBACkB,iBAAiB,EAAE,kCAAkC,EAAE;AACzE,SAAS,gBAAgB,EAAE,mBAAmB,EAAE;AAChD,cAAc,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AAChG;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,iFAAiF;AACjF;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;AACA,yBAAyB,aAAa,EAAE,iCAAiC,EAAE;AAC3E,4BAA4B,wBAAwB,EAAE;AACtD,iBAAiB,iBAAiB,EAAE,YAAY,EAAE;AAClD,iBAAiB,WAAW,EAAE;AAC9B,iBAAiB,WAAW,EAAE;AAC9B,iBAAiB,gBAAgB,EAAE;AACnC,kBAAkB,gBAAgB,EAAE;AACpC,yBAAyB,gBAAgB,EAAE;AAC3C,6BAA6B,qBAAqB,EAAE;;AAEpD;EACE,aAAa;EACb,uDAAuD;EACvD,cAAc;EACd,mBAAmB;AACrB;AACA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,4BAA4B;AAC9B;AACA,YAAY,mBAAmB,EAAE,mBAAmB,EAAE,QAAQ,EAAE;;AAEhE;EACE,mCAAmC;EACnC,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;AACA,qBAAqB,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;;AAE/F,gBAAgB,gBAAgB,EAAE,kBAAkB,EAAE;AACtD,cAAc,sBAAsB,EAAE;AACtC,oBAAoB,gBAAgB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AAC7E,sBAAsB,WAAW,EAAE,cAAc,EAAE;AACnD,uBAAuB,uBAAuB,EAAE;AAChD,4BAA4B,eAAe,EAAE;AAC7C,qCAAqC,2BAA2B,EAAE;;AAElE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;AACA,+BAA+B,0BAA0B,EAAE;AAC3D,mBAAmB,YAAY,EAAE,eAAe,EAAE;;AAElD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,cAAc;AAChB;AACA,gBAAgB,2BAA2B,EAAE;AAC7C,oBAAoB,wBAAwB,EAAE;;AAE9C,iBAAiB;AACjB;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,sCAAsC;EACtC,wBAAwB;AAC1B;AACA,2BAA2B,eAAe,EAAE,WAAW,EAAE;AACzD,sCAAsC,WAAW,EAAE,eAAe,EAAE;AACpE,iBAAiB,iBAAiB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACtE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;AACA,sBAAsB,2BAA2B,EAAE;AACnD,4BAA4B,OAAO,EAAE,eAAe,EAAE;;AAEtD,oCAAoC;AACpC,WAAW,mBAAmB,EAAE;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;AACA,gBAAgB,gBAAgB,EAAE,eAAe,EAAE,gBAAgB,EAAE;;AAErE,wCAAwC;AACxC,WAAW,aAAa,EAAE,SAAS,EAAE,uBAAuB,EAAE,eAAe,EAAE;AAC/E,WAAW,eAAe,EAAE;AAC5B,gBAAgB,eAAe,EAAE;;AAEjC,WAAW;AACX,iBAAiB,yBAAyB,EAAE,gBAAgB,EAAE,eAAe,EAAE;AAC/E,oBAAoB,iBAAiB,EAAE,0BAA0B,EAAE;AACnE,gCAAgC,eAAe,EAAE;AACjD,kBAAkB,mCAAmC,EAAE,gBAAgB,EAAE;AACzE,oBAAoB,uCAAuC,EAAE,gBAAgB,EAAE,eAAe,EAAE;;AAEhG;EACE,UAAU,uBAAuB,EAAE;EACnC,YAAY,qCAAqC,EAAE;EACnD,mBAAmB,eAAe,EAAE,EAAE,4BAA4B;EAClE,iBAAiB,YAAY,EAAE,WAAW,EAAE;EAC5C,WAAW,sBAAsB,EAAE;EACnC,0BAA0B,cAAc,EAAE,WAAW,EAAE;AACzD","sourcesContent":["/* ── Quote editor & summary ── */\n.q-toolbar { flex-wrap: wrap; }\n.q-body { padding: 12px 16px 32px; }\n.q-muted { color: var(--text-muted); font-size: 12px; }\n.q-warn { color: #dcaa00; font-size: 12px; }\n.q-error { color: var(--red); font-size: 12px; }\n.q-unsaved { color: #dcaa00; font-size: 12px; font-style: italic; }\n.q-spacer { flex: 1; }\n.q-pad { padding: 8px 0; }\n.q-r,\n.q-table th.q-r { text-align: right; font-variant-numeric: tabular-nums; }\n.q-tag { font-weight: 600; white-space: nowrap; }\n.q-ellipsis { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 280px; }\n.q-banner {\n  background: var(--red-dim);\n  color: var(--text-primary);\n  padding: 8px 12px;\n  border-radius: 4px;\n  margin-bottom: 12px;\n}\n\n/* Scoped under .q-body so they beat the global input:not([type=checkbox]) rule */\n.q-body .q-input {\n  background: var(--bg-input);\n  border: 1px solid var(--border);\n  border-radius: 2px;\n  color: var(--text-primary);\n  font-size: 12px;\n  padding: 3px 6px;\n  width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n}\n.q-body .q-input:focus { outline: none; border-color: var(--accent-light); }\n.q-body .q-input:disabled { color: var(--text-muted); }\n.q-body .q-num { text-align: right; width: 100px; }\n.q-body .q-qty { width: 64px; }\n.q-body .q-pct { width: 64px; }\n.q-body .q-ean { min-width: 120px; }\n.q-body .q-wide { min-width: 220px; }\n.q-body select.q-input { min-width: 120px; }\n.q-body .q-input.q-missing { border-color: #dcaa00; }\n\n.q-header {\n  display: grid;\n  grid-template-columns: minmax(200px, 360px) 140px 150px;\n  gap: 10px 14px;\n  margin-bottom: 16px;\n}\n.q-header label,\n.q-inline {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  font-size: 11px;\n  color: var(--text-secondary);\n}\n.q-inline { flex-direction: row; align-items: center; gap: 6px; }\n\n.q-section {\n  border-top: 1px solid var(--border);\n  padding: 12px 0 8px;\n}\n.q-section-head {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-bottom: 8px;\n}\n.q-section-head h3 { margin: 0; font-size: 14px; font-weight: 600; color: var(--text-primary); }\n\n.q-table-wrap { overflow-x: auto; margin-bottom: 8px; }\n.q-table td { vertical-align: middle; }\n.q-table tfoot td { font-weight: 600; border-bottom: none; padding-top: 6px; }\n.q-table .q-actions { width: 28px; padding: 0 4px; }\n.q-table tr:hover td { background: transparent; }\n.q-summary tr.q-clickable { cursor: pointer; }\n.q-summary tr.q-clickable:hover td { background: var(--bg-hover); }\n\n.q-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  background: none;\n  border: none;\n  color: var(--text-muted);\n  font-size: 12px;\n  cursor: pointer;\n  padding: 2px 0;\n}\n.q-link:hover:not(:disabled) { color: var(--text-primary); }\n.q-link:disabled { opacity: 0.5; cursor: default; }\n\n.q-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  background: none;\n  border: none;\n  color: var(--text-secondary);\n  font-size: 12px;\n  cursor: pointer;\n  padding: 4px 0;\n}\n.q-toggle svg { transition: transform 0.15s; }\n.q-toggle .q-open { transform: rotate(90deg); }\n\n/* Cable picker */\n.q-picker {\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  background: var(--bg-secondary);\n  margin-bottom: 10px;\n}\n.q-picker-bar {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 6px;\n  padding: 8px;\n  border-bottom: 1px solid var(--border);\n  color: var(--text-muted);\n}\n.q-body .q-picker-search { flex: 1 1 160px; width: auto; }\n.q-body .q-picker-bar .group-filter { width: auto; flex: 0 1 170px; }\n.q-picker-list { max-height: 320px; overflow-y: auto; padding: 4px 0; }\n.q-picker-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 3px 10px;\n  font-size: 12px;\n  cursor: pointer;\n}\n.q-picker-row:hover { background: var(--bg-hover); }\n.q-picker-row .q-ellipsis { flex: 1; max-width: none; }\n\n/* Item groups (one per .sep file) */\n.q-group { margin-bottom: 14px; }\n.q-group-head {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 4px;\n}\n.q-group-name { font-weight: 600; font-size: 13px; max-width: 320px; }\n\n/* Hours: rates next to the hour lines */\n.q-hours { display: flex; gap: 16px; align-items: flex-start; flex-wrap: wrap; }\n.q-rates { flex: 0 1 320px; }\n.q-hour-lines { flex: 1 1 480px; }\n\n/* Totals */\n.q-total-table { border-collapse: collapse; min-width: 420px; font-size: 13px; }\n.q-total-table td { padding: 4px 10px; color: var(--text-primary); }\n.q-total-table td:first-child { padding-left: 0; }\n.q-total-sub td { border-top: 1px solid var(--border); font-weight: 600; }\n.q-total-grand td { border-top: 2px solid var(--text-muted); font-weight: 700; font-size: 15px; }\n\n@media (max-width: 768px), (hover: none) and (max-width: 1024px) {\n  .q-body { padding: 10px 12px 32px; }\n  .q-header { grid-template-columns: minmax(0, 1fr); }\n  .q-body .q-input { font-size: 16px; } /* no zoom on focus in iOS */\n  .q-total-table { min-width: 0; width: 100%; }\n  .q-hours { flex-direction: column; }\n  .q-rates, .q-hour-lines { flex: 1 1 auto; width: 100%; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
